import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_LANGUAGES } from '../config/supportedLanguages';
import { getCurrentLanguageFromUrl } from '../utils/languageUtils';

export const useLanguage = () => {
  const { i18n } = useTranslation();

  const changeLanguage = useCallback((language: string) => {
    // Validate that language is a supported language code
    if (!Object.keys(SUPPORTED_LANGUAGES).includes(language)) {
      console.warn(`Unsupported language code: ${language}`);
      language = 'vi'; // Default to Vietnamese if invalid
    }

    localStorage.setItem('language', language);
    i18n.changeLanguage(language);

    // Reset path to root
    window.location.replace('/');
    return true;
  }, [i18n]);

  const getCurrentLanguage = useCallback((): string => {
    const lang = getCurrentLanguageFromUrl();
    if (Object.keys(SUPPORTED_LANGUAGES).includes(lang)) {
      return lang;
    }
    return i18n.language && Object.keys(SUPPORTED_LANGUAGES).includes(i18n.language) 
      ? i18n.language 
      : 'vi';
  }, [i18n.language]);

  const getAvailableLanguages = useCallback(() => {
    return SUPPORTED_LANGUAGES;
  }, []);

  return {
    changeLanguage,
    getCurrentLanguage,
    getAvailableLanguages,
  };
};
